"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var g2_1 = require("@antv/g2");
var bar_label_1 = require("../../../bar/component/label/bar-label");
var StackBarLabels = /** @class */ (function (_super) {
    tslib_1.__extends(StackBarLabels, _super);
    function StackBarLabels() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    StackBarLabels.prototype.adjustPosition = function (label, shape) {
        var labelRange = label.getBBox();
        var shapeRange = shape.getBBox();
        if (shapeRange.width <= labelRange.width) {
            label.attr('opacity', 0);
            label.attr('fillOpacity', 0);
            label.attr('strokeOpacity', 0);
            label.set('capture', false);
        }
    };
    return StackBarLabels;
}(bar_label_1.BarLabels));
g2_1.registerElementLabels('stackBarLabel', StackBarLabels);
//# sourceMappingURL=stack-bar-label.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@antv/g2plot/lib/plots/stack-bar/component/label/stack-bar-label.js
// module id = 979
// module chunks = 37